<template>
  <div class="energyWrap">
    <div class="energyContent">
      <div class="leftWrap">
        <div class="conservation energyComWrap">
          <div class="energyComHeader">
            <p>节能降碳</p>
          </div>
          <div class="energyComContent ringLineBox">
            <div class="ringCharts">
              <Proportion :rangeValue="rangeValue" :id="'proportion'" />
            </div>
            <div class="lineCharts">
              <PublicEcharts
                :id="'chartsLine'"
                :chartsData="lineData"
                :type="'darkLine'"
              />
            </div>
          </div>
        </div>
        <div class="giveAnAlarm energyComWrap">
          <div class="energyComHeader">
            <p>能源结构</p>
            <el-dropdown @command="handleCommand">
              <el-button type="primary" size="mini">
                {{ structureChange.name
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(v, i) in timeList"
                  :key="i"
                  :command="beforeHandleCommand('structureChange', v)"
                  >{{ v.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="energyComContent">
            <PublicEcharts
              :id="'structure'"
              :chartsData="structureListData"
              :type="'darkRing'"
            />
          </div>
        </div>
        <div class="electric energyComWrap">
          <div class="energyComHeader">
            <p>用电分析</p>
          </div>
          <div class="energyComContent">
            <PublicEcharts
              :id="'chartsGrowth'"
              :chartsData="growthData"
              :type="'darkLine'"
            />
          </div>
        </div>
      </div>
      <div class="babylonTest">
        <template v-if="picCenterUrl != ''">
          <iframe
            width="100%"
            height="100%"
            :src="picCenterUrl"
            frameborder="0"
            v-if="picCenterType === 'babylon'"
          ></iframe>
          <img v-else style="width: 100%; height: 100%" :src="picCenterUrl" />
        </template>
      </div>
      <div class="contentWrap">
        <div class="carouselBox">
          <el-carousel
            indicator-position="outside"
            style="height: 95%; overflow: hidden"
            :interval="5000"
          >
            <el-carousel-item v-for="(v, i) in energyList" :key="i">
              <ul>
                <li v-for="(item, index) in v" :key="index">
                  <img
                    :src="require('@/assets/images/home/' + item.key + '.png')"
                  />
                  <h5>{{ item.value }}</h5>
                  <p>
                    {{ item.name }} <span>{{ item.unit }}</span>
                  </p>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="rightWrap">
        <div
          class="regionBox energyComWrap"
          @mouseenter="hoverDiv"
          @mouseleave="handleSetInterval"
        >
          <div class="energyComHeader">
            <p>区域能耗</p>
            <el-dropdown @command="handleCommand">
              <el-button type="primary" size="mini">
                {{ regionChange.name
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(v, i) in timeList"
                  :key="i"
                  :command="beforeHandleCommand('regionChange', v)"
                  >{{ v.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="energyComContent">
            <PublicEcharts
              :id="'regionCharts'"
              :chartsData="regionList"
              :type="'darkHorizontalBar'"
            />
          </div>
        </div>
        <div class="departmentBox energyComWrap">
          <div class="energyComHeader">
            <p>部门能耗</p>
            <el-dropdown @command="handleCommand">
              <el-button type="primary" size="mini">
                {{ departmentChange.name
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(v, i) in timeList"
                  :key="i"
                  :command="beforeHandleCommand('departmentChange', v)"
                  >{{ v.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="energyComContent">
            <PublicEcharts
              :id="'departmentCharts'"
              :chartsData="departmentList"
              :type="'darkRose'"
            />
          </div>
        </div>
        <div class="systemBox energyComWrap">
          <div class="energyComHeader">
            <p>系统能耗</p>
            <el-dropdown @command="handleCommand">
              <el-button type="primary" size="mini">
                {{ systemChange.name
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(v, i) in timeList"
                  :key="i"
                  :command="beforeHandleCommand('systemChange', v)"
                  >{{ v.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="energyComContent">
            <SystemCharts :id="'systemCharts'" :chartsData="systemList" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  judgmentUnit,
  getProjectVal,
  getUserInfoVal,
} from "@/assets/js/utils";
import Proportion from "@/components/nengyuanguanli/EnergyManagement/proportion";
import SystemCharts from "@/components/nengyuanguanli/EnergyManagement/systemCharts";
import PublicEcharts from "@/components/PublicEcharts";
export default {
  components: {
    Proportion,
    SystemCharts,
    PublicEcharts,
  },
  data() {
    return {
      engine: null,
      scene: null,
      timer: null,
      timer1: null,
      timer2: null,
      hoverImg: 0,
      hoverImg1: 0,
      hoverImg2: 0,
      structureListData: {
        unit: "kgCO₂",
        dataArr: [],
      },
      growthData: {
        unit: "万kw·h",
        xData: [],
        dataArr: [],
      }, //用电分析charts数据
      lineData: {
        name: "排碳量",
        unit: "万吨",
        xData: ["Q1", "Q2", "Q3", "Q4"],
        dataArr: [],
      },
      regionChange: { name: "今日", value: "DAY" },
      departmentChange: { name: "今日", value: "DAY" },
      systemChange: { name: "今日", value: "DAY" },
      structureChange: { name: "今日", value: "DAY" },
      timeList: [
        { name: "今日", value: "DAY" },
        { name: "本月", value: "MONTH" },
        { name: "本年", value: "YEAR" },
      ],
      regionList: { unit: "", dataArr: [] },
      departmentList: { unit: "", dataArr: [] },
      systemList: [],
      energyList: [],
      rangeValue: null,

      picCenterType: "image", //babylon,image
      picCenterUrl: "",
    };
  },
  methods: {
    async getEnergyList() {
      let res = await api.getEnergyConsumptionSummary({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.energyList = [];
        for (let key in res.data.data) {
          this.energyList.push(res.data.data[key]);
        }
        this.energyList.map((v) => {
          if (judgmentUnit(v, "value", 10000)) {
            v.map((item) => {
              item.value =
                item.value != "-"
                  ? (item.value / 10000).toFixed(2)
                  : item.value;
              item.unit = "万 " + item.unit;
            });
          }
        });
      }
    },
    async getStructureList() {
      this.structureListData.dataArr = [];
      let res = await api.getECStructureList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        dateType: this.structureChange.value,
        key: "EnergyResourceStructure",
      });
      if (res && res.data.code == 200) {
        this.structureListData.dataArr = res.data.data.filter((v) => {
          return v.value;
        });
      }
    },
    handleCommand(command) {
      // console.log(command);
      this[command.type] = command.command;
      if (command.type == "regionChange") {
        this.getRegion();
      } else if (command.type == "departmentChange") {
        this.getDepartment();
      } else if (command.type == "systemChange") {
        this.getEnergyConsumption();
      } else if (command.type == "structureChange") {
        this.getStructureList();
      }
    },
    beforeHandleCommand(type, command) {
      return {
        type: type,
        command: command,
      };
    },
    async getReduce() {
      let res = await api.getMainPageReduce({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: "QUARTER",
      });
      if (res && res.data.code == 200) {
        this.rangeValue = res.data.data.rangeCustom ?? res.data.data.range;
        this.lineData.dataArr = [];
        let arr = [];
        res.data.data.charts.map((v) => {
          arr.push(v.chart);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.lineData.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.lineData.dataArr[i].name = item[i].name;
            this.lineData.dataArr[i].data.push(
              (item[i].data / 10000).toFixed(2)
            );
          });
        }
      }
    },

    async getElectricity() {
      let treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      let res = await api.equipmentEnergyLineDataList({
        assetId: treeAllData.区域位置.id,
        type: "YEAR",
        date: new Date().getFullYear(),
        dateType: "ENERGY_CONSUMPTION",
      });
      if (res && res.data.code == 200) {
        this.growthData.xData = [];
        this.growthData.dataArr = [];
        let arr = [];
        res.data.data.chartParamsList.map((v) => {
          this.growthData.xData.push(dateFtt("MM", new Date(v.time)));
          arr.push(v.assets);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.growthData.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.growthData.dataArr[i].name = item[i].name;
            this.growthData.dataArr[i].data.push(
              (item[i].data / 10000).toFixed(2)
            );
          });
        }
      }
    },
    async getRegion() {
      let res = await api.formDataEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        dateType: this.regionChange.value,
        label: "区域位置",
      });
      if (res && res.data.code == 200) {
        this.regionList.unit = "kw·h";
        this.regionList.dataArr = [];
        let dataArr = Array.from(res.data.data).map((item) => ({
          name: item.name,
          value: item.ecValue,
        }));
        this.regionList.dataArr = dataArr.slice(0, 5);
      }
    },
    async getDepartment() {
      let res = await api.formDataEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        dateType: this.departmentChange.value,
        label: "单位部门",
      });
      if (res && res.data.code == 200) {
        this.departmentList.unit = "kw·h";
        this.departmentList.dataArr = [];
        let arr = Array.from(res.data.data).map((item) => ({
          name: item.name,
          value: item.ecValue,
        }));
        this.departmentList.dataArr = arr
          .sort(function (a, b) {
            return a.value - b.value;
          })
          .filter((v) => {
            return v.value;
          });
      }
    },
    async getEnergyConsumption() {
      let res = await api.formDataEC({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        dateType: this.systemChange.value,
        label: "分项系统",
      });
      if (res && res.data.code == 200) {
        this.systemList = [];
        this.systemList = Array.from(res.data.data)
          .map((item) => ({
            name: item.name,
            value: item.ecValue,
          }))
          .filter((v) => {
            return v.value;
          });
      }
    },
    hoverDiv() {
      clearInterval(this.timer);
    },
    handleSetInterval(index, type) {
      return setInterval(() => {
        index++;
        if (index == this.timeList.length) {
          index = 0;
        }
        this.handleCommand({
          type: type,
          command: this.timeList[index],
        });
      }, 20000);
    },
    async getPicCenter() {
      this.structureListData.dataArr = [];
      let res = await api.EMGetPic(
        {
          keys: "3DModelUrl",
        },
        getProjectVal("Id")
      );
      if (res?.status == 200) {
        const newvalue = res?.data?.[0]?.value;
        this.picCenterType = newvalue.includes("http") ? "babylon" : "image";
        this.picCenterUrl = `${newvalue}?tenant_id=${getUserInfoVal(
          "tenantId"
        )}`;
      }
    },
  },
  mounted() {},
  created() {
    this.getElectricity();
    clearInterval(this.timer);
    clearInterval(this.timer1);
    clearInterval(this.timer2);
    this.timer = null;
    this.timer1 = null;
    this.timer2 = null;
    this.timer = this.handleSetInterval(this.hoverImg, "regionChange");
    this.timer1 = this.handleSetInterval(this.hoverImg1, "departmentChange");
    this.timer2 = this.handleSetInterval(this.hoverImg2, "systemChange");
    this.getStructureList(); //能源结构
    this.getRegion(); //区域能耗
    this.getDepartment(); //部门
    this.getEnergyConsumption(); //分项系统
    this.getEnergyList();
    this.getReduce();
    this.getPicCenter();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
    clearInterval(this.timer2);
    this.timer = null;
    this.timer1 = null;
    this.timer2 = null;
  },
};
</script>

<style scoped lang="scss">
.energyWrap {
  width: 100%;
  height: calc(100% - 2px);
  background: #050b1f;
  overflow: hidden;
  @include setFlexCenter;
  border-top: 2px solid;
  border-image: linear-gradient(
      90deg,
      rgba(4, 16, 40, 1),
      rgba(77, 94, 172, 1),
      rgba(4, 16, 40, 1)
    )
    2 2;
  ::v-deep .el-button--primary {
    background: #222d59;
    color: #aeb2c2;
    border-color: #464d66;
  }
  .energyContent {
    width: 97%;
    height: 96%;
    // @include setFlexBetween;
    position: relative;
    .energyComWrap {
      // border: 1px solid #fff;
      .energyComHeader {
        height: 37px;
        background: url("~@/assets/images/home/border.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        @include setFlexBetween;
        align-items: flex-start;
        p {
          font-weight: bold;
          font-size: 18px;
          color: #fff;
          // line-height: 37px;
          position: relative;
          margin-left: 20px;
        }
      }
      .energyComContent {
        height: calc(100% - 43px);
        width: 96%;
        margin: 0 auto;
        // background: burlywood;
      }
    }
    .leftWrap,
    .rightWrap {
      width: 28%;
      height: 100%;
      // background: #050b1f;
      background: rgba(5, 11, 31, 0.5);
      @include setFlexColumn;
      justify-content: space-between;
    }
    .leftWrap {
      position: absolute;
      top: 0;
      left: 0;
      .conservation {
        width: 100%;
        height: 33%;
        .ringLineBox {
          height: 75%;
          @include setFlexBetween;
          .ringCharts {
            width: 45%;
            height: 100%;
          }
          .lineCharts {
            width: 55%;
            height: 100%;
          }
        }
      }
      .giveAnAlarm {
        width: 100%;
        height: 33%;
      }
      .electric {
        width: 100%;
        height: 33%;
      }
    }
    .rightWrap {
      position: absolute;
      top: 0;
      right: 0;

      .regionBox {
        width: 100%;
        height: 35%;
      }
      .departmentBox {
        width: 100%;
        height: 32%;
      }
      .systemBox {
        width: 100%;
        height: 32%;
      }
    }
    .babylonTest {
      width: 60%;
      // width: 120%;
      height: 80%;
      margin: 0 auto;
      overflow: hidden;
      #container {
        width: 110%;
        height: 100%;
        margin: 0 auto;
      }
    }
    .contentWrap {
      width: 43%;
      height: 20%;
      position: absolute;
      left: 30%;
      bottom: 0;
      .carouselBox {
        height: 100%;
        width: 100%;
        ::v-deep .el-carousel__container {
          height: 95%;
        }
        ul {
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          li {
            width: 50%;
            height: 49%;
            display: flex;
            align-items: center;
            img {
              height: 80%;
            }
            h5 {
              color: #fff;
              font-size: 28px;
              margin: 0 10px;
            }
            p {
              color: #16e9f4;
              span {
                display: block;
                color: #868b99;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
